import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsTipuriConcedii,
      ref: "dataGridRef",
      "allow-column-reordering": false,
      "allow-column-resizing": true,
      "column-auto-width": false,
      "show-borders": true,
      "key-expr": "Type"
    }, {
      editTitle: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px 0 10px 20px","width":"100%"} }, " Editare Tip Concediu ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 240,
          placeholder: "Cauta ..."
        }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          "allow-deleting": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 350,
              height: 410,
              "show-title": true,
              "title-template": "editTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.saveButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, { "col-count": 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, { "data-field": "Name" }),
                _createVNode(_component_DxItem, {
                  "data-field": "NrZile",
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Order",
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Suspended",
                  "editor-type": "dxCheckBox",
                  "css-class": 'checkbox-center',
                  "editor-options": { elementAttr: { style: 'display:flex; justify-content:center; margin-right:110px;' } }
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Type",
          caption: "Tip"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Name",
          caption: "Nume"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Suspended",
          caption: "Suspendat?"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NrZile",
          caption: "Numar Zile"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Order",
          caption: "Comanda"
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, {
              location: "after",
              name: "searchPanel"
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.addPopupVisible,
      "show-title": true,
      width: "350",
      height: "350"
    }, {
      title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare Tip Concediu ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "data-dource": _ctx.newConcediu
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Tip",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newConcediu.Type,
                  onValueChanged: _ctx.onTypeValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Nume",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newConcediu.Name,
                  onValueChanged: _ctx.onNameValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Numar Zile" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxNumberBox, {
                  value: _ctx.newConcediu.NrZile,
                  min: 0,
                  step: 1,
                  "show-spin-buttons": true,
                  "show-clear-button": true,
                  onValueChanged: _ctx.onNrZileValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Numar Zile" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxNumberBox, {
                  value: _ctx.newConcediu.Order,
                  min: 0,
                  step: 1,
                  "show-spin-buttons": true,
                  "show-clear-button": true,
                  onValueChanged: _ctx.onOrderValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Suspendat?",
              "is-required": true,
              "col-span": 2
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_DxCheckBox, {
                    value: _ctx.newConcediu.Suspended,
                    onValueChanged: _ctx.onSuspendedValueChanged
                  }, null, 8, ["value", "onValueChanged"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-dource"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.addButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.closeButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}